import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import {NullAsDefault} from 'views/Shared'
import {renderIf, renderIfElse} from '../../../Shared'
import classNames from "classnames";
import {CourseSubClasses, ListContext} from "../containers/CourseHelpers";
import {getId, getType} from "../../../../apis/model/base";
import {FaUserClock, FaUserGraduate} from "react-icons/fa6";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {ItemInformation} from "../../../AppLocals/Organization/OrganizationEntity";
import {DoubleValueItem} from "../../../AppLocals/CatholicHousehold/components/CatholicHouseholdComponents";
import {FullSideModalLayout} from "../../../../components/Modal/SideModalLayout";
import {ClassroomSvg} from "../../../../components/Svgs/ClassroomSvg";
import {CourseStudentsSearchBinding} from "../../../AppLocals/Course/CourseClass/CourseStudentForm";
import {CourseEnrollmentsByCourseSearchBinding} from "../containers/CourseEnrollmentsByCourse";
import {BsFillCalendar2DateFill} from "react-icons/bs";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";

/**
 * Xác định trạng thái hiển thị của khóa học
 * @returns {{ label: string, className: string } | null}
 */
const getCourseStatusBadge = (item, t) => {
    const {is_expired, is_register_expired, time_open} = item ?? {}

    // Đã kết thúc (hết hạn khóa)
    if (is_expired) {
        return {
            label: t('ended'),
            className: 'bg-gray-200 text-gray-600',
        }
    }

    // Hết hạn đăng ký nhưng khóa vẫn còn chạy
    if (is_register_expired) {
        return {
            label: t('registration closed'),
            className: 'bg-orange-100 text-orange-700',
        }
    }

    // Chưa mở (time_open trong tương lai)
    if (time_open) {
        const openDate = new Date(time_open)
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        if (openDate > today) {
            return {
                label: t('upcoming'),
                className: 'bg-blue-100 text-blue-700',
            }
        }
    }

    // Đang diễn ra
    return {
        label: t('ongoing'),
        className: 'bg-green-100 text-green-700',
    }
}

export const renderCourse = ({renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const {time_open, time_close, description, academic_field, academic_year} = item ?? {}
    const {isSm} = useContext(LayoutContext)

    return (
        <ListContext.Consumer key={index}>
            {({actionIndex, setActionIndex}) => {
                const activeClassTab = actionIndex?.current === item?.id && actionIndex?.menuKey === "course_classes"
                const activeEnrollmentTab = actionIndex?.current === item?.id && actionIndex?.menuKey === "course_enrollments"
                const activeStudentTab = actionIndex?.current === item?.id && actionIndex?.menuKey === "course_students"
                return (
                    <Translate>
                        {(t) => {
                            const statusBadge = getCourseStatusBadge(item, t)
                            return (
                                <div className="px-3 py-2 border border-color-50 background shadow-md hover:scale-2xs rounded-xl custom-item-render relative">
                                    <div className="mb-2 pb-2 border-b flex flex-col gap-1">
                                        {/* Title + badge cùng hàng flex, badge không bao giờ đè title */}
                                        <div className="flex items-start gap-2">
                                            <h2 className="flex-1 min-w-0">
                                                <Link
                                                    to={getLinkToDetail(item)}
                                                    className="font-bold text-lg text-color-000 tracking-wide no-underline leading-snug max-lines-1">
                                                    {getTitle(item)}
                                                </Link>
                                            </h2>
                                            {statusBadge && (
                                                <span
                                                    className={classNames(
                                                        'flex-shrink-0 text-2xs font-semibold px-2 py-1 rounded-full leading-5 whitespace-no-wrap mt-1',
                                                        statusBadge.className
                                                    )}>
                                                {statusBadge.label}
                                            </span>
                                            )}
                                        </div>
                                        {renderIf(
                                            _.some([academic_field, academic_year]),
                                            <span className="font-medium text-xs text-indigo-600 italic tracking-wide max-lines-1">
                                            {renderIfElse(
                                                academic_field && academic_year,
                                                `${academic_field} - ${academic_year}`,
                                                academic_field || academic_year
                                            )}
                                        </span>
                                        )}
                                    </div>
                                    {renderIf(
                                        _.some([time_open, time_close, description]),
                                        <div className="flex flex-col gap-1"> {/* Thêm gap-1 */}
                                            {renderIf(
                                                _.some([time_open, time_close]),
                                                <DoubleValueItem
                                                    showIcon={true}
                                                    labelFirst="time"
                                                    valueFirst={formatSimplifyDate(time_open, 'medium')}
                                                    labelSecond={time_close && ' - ' || ''}
                                                    valueSecond={time_close && formatSimplifyDate(time_close, 'medium')}
                                                    className="text-sm italic" // Tăng text-xs -> text-sm
                                                />
                                            )}
                                            {renderIf(
                                                description,
                                                <div className="text-sm text-color-300 tracking-wider max-lines-2"> {/* Tăng text-xs -> text-sm */}
                                                    {description}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    {renderIf(
                                        setActionIndex,
                                        <div className="flex flex-col gap-3 mt-2"> {/* Tăng gap-2 -> gap-3, mt-1 -> mt-2 */}
                                            <div className="flex items-center gap-5 md:gap-12"> {/* Tăng gap-3 -> gap-5, md:gap-10 -> md:gap-12 */}
                                                <div
                                                    onClick={() => {
                                                        if (activeClassTab) {
                                                            setActionIndex({
                                                                current: null,
                                                                menuKey: 'course_classes'
                                                            })
                                                        } else {
                                                            setActionIndex({
                                                                current: item?.id,
                                                                menuKey: 'course_classes'
                                                            })
                                                        }
                                                    }}
                                                    className={classNames("flex items-center gap-1 cursor-pointer",
                                                        activeClassTab ? "font-bold text-primary hover:text-primary-700" : "font-medium text-green-600 hover:text-green-700"
                                                    )}>
                                                    <ClassroomSvg style={{marginTop: 1}} size={16} // Tăng size 14 -> 16
                                                                  className={activeClassTab ? "text-primary" : "text-green-300"}/>
                                                    <span
                                                        className="text-base uppercase tracking-wide leading-tight"> {/* Tăng text-sm -> text-base */}
                                                        {` - ${t('classes')}`}
                                                </span>
                                                </div>
                                                <div
                                                    onClick={() => {
                                                        if (activeEnrollmentTab) {
                                                            setActionIndex({
                                                                current: null,
                                                                menuKey: 'course_enrollments'
                                                            })
                                                        } else {
                                                            setActionIndex({
                                                                current: item?.id,
                                                                menuKey: 'course_enrollments'
                                                            })
                                                        }
                                                    }}
                                                    className={classNames("flex items-center gap-1 cursor-pointer",
                                                        activeEnrollmentTab ? "font-bold text-primary hover:text-primary-700" : "font-medium text-green-600 hover:text-green-700"
                                                    )}>
                                                    <FaUserClock size={16} // Tăng size 14 -> 16
                                                                 className={activeEnrollmentTab ? "text-primary" : "text-green-300"}/>
                                                    <span
                                                        className="text-base uppercase tracking-wide leading-tight"> {/* Tăng text-sm -> text-base */}
                                                        {` - ${t('enrollments')}`}
                                                </span>
                                                </div>
                                                <div
                                                    onClick={() => {
                                                        if (activeStudentTab) {
                                                            setActionIndex({
                                                                current: null,
                                                                menuKey: 'course_students'
                                                            })
                                                        } else {
                                                            setActionIndex({
                                                                current: item?.id,
                                                                menuKey: 'course_students'
                                                            })
                                                        }
                                                    }}
                                                    className={classNames("flex items-center gap-1 cursor-pointer",
                                                        activeStudentTab ? "font-bold text-primary hover:text-primary-700" : "font-medium text-green-600 hover:text-green-700"
                                                    )}>
                                                    <FaUserGraduate size={14} // Tăng size 12 -> 14
                                                                    className={activeStudentTab ? "text-primary" : "text-green-300"}/>
                                                    <span
                                                        className="text-base uppercase tracking-wide leading-tight"> {/* Tăng text-sm -> text-base */}
                                                        {` - ${t('students')}`}
                                                </span>
                                                </div>
                                            </div>
                                            {renderIf(
                                                activeClassTab,
                                                <div
                                                    className="p-3 md:p-4 pb-5"> {/* Tăng p-2 -> p-3, md:p-3 -> md:p-4, pb-4 -> pb-5 */}
                                                    <CourseSubClasses
                                                        owner_id={getId(item?.owner)}
                                                        owner_type={getType(item?.owner)}
                                                        item={item}
                                                    />
                                                </div>
                                            )}
                                            {renderIf(
                                                activeEnrollmentTab,
                                                <FullSideModalLayout
                                                    right={true}
                                                    onCancel={() => {
                                                        setActionIndex({
                                                            current: null,
                                                            menuKey: 'course_enrollments'
                                                        })
                                                    }}
                                                    title={
                                                        <span className="font-bold text-color-000 tracking-wide">
                                                        {t('registers for course')}
                                                    </span>
                                                    }>
                                                    <div
                                                        className="px-3 md:px-5 mb-6"> {/* Tăng px-2 -> px-3, md:px-4 -> md:px-5 */}
                                                        <CourseEnrollmentsByCourseSearchBinding
                                                            owner_id={getId(item?.owner)}
                                                            owner_type={getType(item?.owner)}
                                                            course_id={item?.id}
                                                            showHeader={false}
                                                        />
                                                    </div>
                                                </FullSideModalLayout>
                                            )}
                                            {renderIf(
                                                activeStudentTab,
                                                <FullSideModalLayout
                                                    right={true}
                                                    onCancel={() => {
                                                        setActionIndex({current: null, menuKey: 'course_students'})
                                                    }}
                                                    title={
                                                        <span className="font-bold text-color-000 tracking-wide">
                                                        {t('students for course')}
                                                    </span>
                                                    }>
                                                    <div
                                                        className="px-1 md:px-2 mb-6"> {/* Tăng px-0 -> px-1, md:px-1 -> md:px-2 */}
                                                        <CourseStudentsSearchBinding
                                                            owner_id={getId(item?.owner)}
                                                            owner_type={getType(item?.owner)}
                                                            item={item}
                                                            showHeader={false}
                                                        />
                                                    </div>
                                                </FullSideModalLayout>
                                            )}
                                        </div>
                                    )}
                                    {_.isFunction(renderContextMenu) && (
                                        <div className="absolute right-0 top-5 contextIcon">
                                            {renderContextMenu(item)}
                                        </div>
                                    )}
                                </div>
                            )
                        }}
                    </Translate>
                )
            }}
        </ListContext.Consumer>
    )
}

export const renderCourseCompact = ({showOrg = true, renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const {time_open, time_close, owner} = item ?? {}

    return (
        <Translate key={index}>
            {(t) => {
                const statusBadge = getCourseStatusBadge(item, t)
                return (
                    <div className="px-3 py-2 background-50 hover:scale-2xs hover:shadow-md rounded-xl custom-item-render relative">
                        <div className="flex flex-col gap-1">
                            {/* Title + badge cùng hàng */}
                            <div className="flex items-start gap-2">
                                <Link
                                    to={getLinkToDetail(item)}
                                    className="flex-1 min-w-0 font-bold text-base text-color-000 no-underline leading-snug tracking-wide">
                                    {getTitle(item)}
                                </Link>
                                {statusBadge && (
                                    <span
                                        className={classNames(
                                            'flex-shrink-0 text-2xs font-semibold px-2 py-1 rounded-full leading-5 whitespace-no-wrap mt-1',
                                            statusBadge.className
                                        )}>
                                    {statusBadge.label}
                                </span>
                                )}
                            </div>
                            {renderIf(
                                showOrg,
                                <ItemInformation
                                    showIcon={true} label="organization by"
                                    className="text-xs italic truncate"
                                    value={
                                        <Link to={getLinkToDetail(owner)}
                                              className="font-medium text-blue-500 no-underline">
                                            {getTitle(owner)}
                                        </Link>
                                    }
                                />
                            )}
                            {renderIf(
                                _.some([time_open, time_close]),
                                <DoubleValueItem
                                    iconFirst={<BsFillCalendar2DateFill size={12} className="mx-1 text-green-500"/>}
                                    valueFirst={formatSimplifyDate(time_open, 'medium')}
                                    labelSecond={time_close && ' - ' || ''}
                                    valueSecond={time_close && formatSimplifyDate(time_close, 'medium')}
                                    className="text-xs italic tracking-wide truncate"
                                />
                            )}
                        </div>
                        {_.isFunction(renderContextMenu) && (
                            <div className="absolute right-5 top-5 contextIcon">
                                {renderContextMenu(item)}
                            </div>
                        )}
                    </div>
                )
            }}
        </Translate>
    )
}